import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage.js';
import AdminDashboard from './pages/AdminDashboard.js';
import AdminMenagment from './pages/AdminMenagment.js';
import AdminCalendarPage from './pages/AdminCalendarPage';
import AdminCourses from './pages/AdminCourses.js';
import AdminAttendancePage from './pages/AdminAttendancePage.js';
import AdminGradesPage from './pages/AdminGradesPage.js';
import AdminMessages from './pages/AdminMessages.js';
import AdminMail from './pages/AdminMail.js';
import AdminReports from './pages/AdminReports.js';
import AdminSettings from './pages/AdminSettings.js';
import LecturerDashboard from './pages/LecturerDashboard.js';
import LecturerStudents from './pages/LecturerStudents.js';
import LecturerSessions from './pages/LecturerSessions.js';
import LecturerTasks from './pages/LecturerTasks.js';
import LecturerGrades from './pages/LecturerGrades.js';
import LecturerMaterials from './pages/LecturerMaterials.js';
import LecturerMessages from './pages/LecturerMessages.js';
import LecturerAttendance from './pages/LecturerAttendance.js';
import StudentDashboard from './pages/StudentDashboard.js';
import StudentGrades from './pages/StudentGrades.js';
import StudentCalendar from './pages/StudentCalendar.js';
import StudentMaterials from './pages/StudentMaterials.js';
import StudentProfile from './pages/StudentProfile.js';
import StudentMessages from './pages/StudentMessages.js';
import StudentTasks from './pages/StudentTasks.js';
import Invite from './pages/Invite.js';
import PrivacyPolicy from './pages/PrivacyPolicy.js';
import SystemRegulations from './pages/SystemRegulations.js';
import LecturerProfile from './pages/LecturerProfile.js';
import AdminMaterials from './pages/AdminMaterials.js';
import AdminAccountPage from './pages/AdminAccountPage.js';
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/invite" element={<Invite />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/system-regulations" element={<SystemRegulations />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path='/admin/management' element={<AdminMenagment />} />
        <Route path="/admin/calendar" element={<AdminCalendarPage />} />
        <Route path='/admin/courses' element={<AdminCourses />} />
        <Route path="/admin/attendance" element={<AdminAttendancePage />} />
        <Route path="/admin/grades" element={<AdminGradesPage />} />
        <Route path='/admin/messages' element={<AdminMessages />} />
        <Route path='/admin/mail' element={<AdminMail />} />
        <Route path='/admin/materials' element={<AdminMaterials />} />
        <Route path='/admin/reports' element={<AdminReports />} />
        <Route path='/admin/settings' element={<AdminSettings />} />
        <Route path='/admin/account' element={<AdminAccountPage />} />
        <Route path='/lecturer/dashboard' element={<LecturerDashboard />} />
        <Route path='/lecturer/students' element={<LecturerStudents />} />
        <Route path='/lecturer/sessions' element={<LecturerSessions />} />
        <Route path='/lecturer/tasks' element={<LecturerTasks />} />
        <Route path='/lecturer/grades' element={<LecturerGrades />} />
        <Route path='/lecturer/materials' element={<LecturerMaterials />} />
        <Route path='/lecturer/messages' element={<LecturerMessages />} />
        <Route path='/lecturer/attendance' element={<LecturerAttendance />} />
        <Route path='/lecturer/profile' element={<LecturerProfile />} />
        <Route path='/student/dashboard' element={<StudentDashboard />} />
        <Route path='/student/grades' element={<StudentGrades />} />
        <Route path='/student/schedule' element={<StudentCalendar />} />
        <Route path='/student/tasks' element={<StudentTasks />} />
        <Route path='/student/messages' element={<StudentMessages />} />
        <Route path='/student/materials' element={<StudentMaterials />} />
        <Route path='/student/profile' element={<StudentProfile />} />
      </Routes>
    </Router>
  );
}

export default App;
